export enum AdEvents {
  SIGNUP = 'signup',
}

// 发送广告投流事件
export function sendAdEvent<T>(eventName: string, eventData?: T) {
  window.uetq = window.uetq || []
  window.uetq.push('event', eventName, eventData || {})
}
